export default __webpack_public_path__ + "static/media/mt_ln_5.12a6b57e.png";